import { Badge } from "@/components/ui/badge";
import React, { useEffect, useRef, useState } from "react";
import Link from "next/link";
import { useToast } from "@/components/ui/use-toast";
import { Card, CardContent } from "@/components/ui/card";
import { isAdmin } from "@/lib/api/client-authentication";
import { getMedia } from "@/services/media";
import { VideoAction } from "@/app/api/user/video/route";
import { CheckCircle } from "lucide-react";
enum VideoType {
	Skill = "Skill",
	Promotional = "Products and Businesses",
}

const VideoStatus: { [key: string]: string } = {
	REPORTED: "Reported",
	ACTIVE: "Active",
	FLAGGED: "Flagged",
	PENDING_MODERATION: "Moderation Pending",
};

export const VideoOverview = (props: any) => {
	const timeoutId = useRef<NodeJS.Timeout | null>(null);
	const [isUserAdmin, setIsUserAdmin] = useState<boolean>(false);
	const [showPreview, setShowPreview] = useState<boolean>(false);
	const { toast } = useToast();
	const activateEdit = () => {
		props.activateEdit(props.video.id);
	};

	const disable = async () => {

		const toastId = toast({
			title: "Removing",
		});

		try{
			await fetch("/api/user/video", {
				method: "PATCH",
				body: JSON.stringify({
					userId: props.userId,
					videoId: props.video.id,
					videoAction: VideoAction.DISABLEVIDEO,
				}),
			});

			toastId.update(
				toast({
					variant: "default",
					duration: 1300,
					action: (
						<div className="w-full flex items-center !ml-0">
							<CheckCircle color="#22c55e" className="mr-2" />
							<span className="text-sm font-semibold">Done</span>
						</div>
					),
				})
			);
			
			props.setVideos((current: any) =>
				current.filter((vid: any) => vid.id !== props.video.id)
			);

		} catch (e: any) {
			toastId.update(
				toast({
					title: "Failed to remove video",
					description: e.message,
					variant: "destructive",
				})
			);
		}
	};

	const handleMouseEnter = (e: any) => {
		const vid = e.target;
		vid.play();
	};

	const handleMouseLeave = (e: any) => {
		const vid = e.target;
		vid.currentTime = 0;
		vid.pause();
	};

	const checkIfUserIsAdmin = async () => {
		const result = await isAdmin();
		setIsUserAdmin(result);
	};

	useEffect(() => {
		checkIfUserIsAdmin();
	}, []);

	if (props.video?.id != "")
		return (
			<>
				<Card>
					<CardContent>
						<div className="pt-6 flex flex-col lg:items-center lg:flex-row lg:justify-start border-gray-500 rounded ">
							<div className="relative m-0 w-full max-w-2xl lg:w-[40%] lg:h-[40%] lg:mr-14">
								<div className="absolute inset-0 flex items-center justify-center">
									<img
										className="w-8 h-8 opacity-60"
										src="/images/play-icon.png"
									/>
								</div>

								<Link href={`/watch/${props.video?.id}`}>
									<video
										onMouseEnter={handleMouseEnter}
										onMouseLeave={handleMouseLeave}
										preload="metadata"
										muted
										className="w-full h-full"
										poster={
											props.video.thumbnail != ""
												? getMedia(props.video?.thumbnail)
												: "/images/single-video.png"
										}>
										<source
											src={`${getMedia(
												props?.video?.location
											)}#t=0,10`}
											type="video/mp4"
										/>
									</video>
								</Link>
							</div>

							<div className="flex-grow pt-4 lg:pt-0">
								<span className="font-bold mr-2">
									{props.video?.title}
								</span>
								{!props.isViewer && props.video?.featured && (
									<span>
										<Badge className="uppercase font-bold">
											Featured
										</Badge>
									</span>
								)}

								<p>{props.video?.description}</p>

								<p className="flex flex-wrap py-7 gap-y-1">
									{props.video?.tags.map((tag: string) =>
										tag != "" ? (
											<span
												className="bg-red-500 px-2 text-white rounded-full mr-1"
												key={tag}>
												{tag}
											</span>
										) : null
									)}
								</p>

								<span>
									<b>Type: </b>
									{props.video?.type == "Both" ? (
										<>
											{VideoType.Skill}, {VideoType.Promotional}
										</>
									) : (
										<>
											{props.video?.type == "Promotional"
												? VideoType.Promotional
												: props.video?.type}
										</>
									)}
								</span>

								<p>
									<b>Views: </b>
									{props.video?.watchCount}
								</p>

								{!props.isViewer && (
									<p>
										<b>Status: </b>
										{VideoStatus[props.video?.Status]}
									</p>
								)}

								<div className="mt-4">
									{!props.isViewer && (
										<>
											<button
												className="px-4 py-1 mr-2 mb-2 text-sm text-white bg-gray-600 rounded hover:bg-gray-500"
												onClick={activateEdit}>
												Edit
											</button>

											<button
												className="px-4 py-1 text-sm text-white bg-red-600 rounded hover:bg-red-500"
												onClick={disable}>
												Remove
											</button>
										</>
									)}
								</div>
							</div>
						</div>
					</CardContent>
				</Card>
			</>
		);
};
